import * as React from 'react';
import Paper from '@mui/material/Paper';
import Menu from '../../../pages/menu/menu';
import { Box, IconButton } from '@mui/material';
import { Link } from 'react-router-dom';
import { Help as HelpIcon, Settings as SettingsIcon, Close as CloseIcon } from '@mui/icons-material';
import { useWrapperNavigation } from '../../../../hooks/use-wrapper-navigation';
import UserButton from './user-button';
import config from '../../../../config/config.json';
import { useEventBus } from '../../../../hooks/use-event-bus/use-event-bus';

const TopNavMenuMobile = React.forwardRef<HTMLDivElement, { onClose: () => void }>(({ onClose }, ref) => {
  const { windowUrls, activeFrame } = useWrapperNavigation();
  const { publish } = useEventBus();

  return (
    <Paper
      ref={ref}
      sx={{
        backgroundColor: '#004763',
        borderRadius: 0,
        zIndex: 1000,
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        overflow: 'hidden'
      }}
    >
      <Box
        sx={{
          background: '#05374A',
          display: 'flex',
          justifyContent: 'flex-end',
          padding: '10px 24px 0'
        }}
      >
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          background: '#05374A',
          padding: '0px 24px 10px 0'
        }}
      >
        <IconButton
          sx={{
            width: 48,
            height: 48,
            margin: '11px 0 11px 0px',
            borderRadius: 12,
            color: activeFrame === 'settings' ? '#ffffff' : '#80979F',
            backgroundColor: activeFrame === 'settings' ? '#032F40' : 'transparent',
            '&:hover': {
              backgroundColor: activeFrame === 'settings' ? '#032F40' : '#265D7C'
            },
            '&:focus-visible': {
              border: '2px solid #1EB9FB'
            }
          }}
          component={Link}
          to={windowUrls.settings}
          onClick={onClose}
        >
          <SettingsIcon />
        </IconButton>
        <IconButton
          sx={{
            width: 48,
            height: 48,
            margin: '11px 0 11px 0px',
            borderRadius: 12,
            color: '#80979F',
            '&:hover': {
              backgroundColor: '#265D7C'
            },
            '&:focus-visible': {
              border: '2px solid #1EB9FB'
            }
          }}
          onClick={() => {
            publish({
              messageType: 'navigate',
              data: {
                pathname: config.support.url,
                crossFrame: true,
                replaceState: false
              }
            });
          }}
        >
          <HelpIcon />
        </IconButton>
        <UserButton />
      </Box>
      <Box
        sx={{
          height: 'calc(100% - 130px)',
          overflow: 'auto'
        }}
      >
        <Menu onClick={onClose} />
      </Box>
    </Paper>
  );
});

export default TopNavMenuMobile;
